module.exports = __webpack_public_path__ + "images/top_sku-icon-main-2cc74aba.png";